import { Controller } from "@hotwired/stimulus"

// Shows the bonus per hour of every step: amount of the step ÷ base hours of the table.
export default class extends Controller {
  static targets = ["base", "row"]

  connect() {
    this.update()
  }

  // Steps added by the nested form
  rowTargetConnected() {
    this.update()
  }

  update() {
    const base = parseFloat(this.baseTarget.value)
    const format = new Intl.NumberFormat(document.documentElement.lang, { style: "currency", currency: "EUR" })

    this.rowTargets.forEach((row) => {
      const amount = parseFloat(row.querySelector("[data-bonus-rate-amount]").value)
      const output = row.querySelector("[data-bonus-rate-output]")
      output.textContent = base > 0 && amount >= 0 ? `${format.format(amount / base)}/h` : ""
    })
  }
}
